import * as React from "react"
import { Form, Tooltip } from "antd"
import { Select } from "components-design-system"
import WorkflowModalHeading from "components/WorkflowModalForm/WorkflowModalHeading/WorkflowModalHeading"
import "./InformTeamWorkflowFields.scss"

// utils
import useWorkflowTeam from "components/WorkflowModalForm/utils/useWorkflowTeam"
import { emailsValidator } from "utilities/antFormUtils"

const InformTeamWorkflowFields = ({ form, informTeam, setInformTeam }) => {
  const { teamOptions, teamIds } = useWorkflowTeam()

  const resetNotifyFields = () => {
    form.setFieldValue(["inform_team_data", "inform_team_ids"], teamIds)
  }

  const InformTeamSwitch = ({ value, onChange }) => (
    <WorkflowModalHeading
      title="Inform team"
      suffix={
        <>
          <Tooltip title="Informing Team will provide a status update to the recipients listed below. This update will include information about completed, current, and upcoming steps, along with relevant dates and assignees.">
            <i className="fal fa-info-circle" />
          </Tooltip>{" "}
          {value && form.isFieldTouched(["inform_team_data", "inform_team_ids"]) && (
            <a
              className="inform-team-fields-reset"
              onClick={resetNotifyFields}
            >
              Reset
            </a>
          )}
        </>
      }
      switchProps={{
        checked: value,
        onChange,
      }}
    />
  )

  return (
    <div className="workflow-card inform-team-workflow-fields">
      <Form.Item
        name="inform_team"
        noStyle
      >
        <InformTeamSwitch
          form={form}
          value={informTeam}
          onChange={setInformTeam}
        />
      </Form.Item>
      {informTeam && (
        <>
          <Form.Item
            name={["inform_team_data", "inform_team_ids"]}
            label="To"
            rules={[{ required: informTeam }]}
          >
            <Select
              mode="tags"
              placeholder="Team members"
              options={teamOptions}
              allowClear
            />
          </Form.Item>
          <Form.Item
            label="CC"
            name={["inform_team_data", "inform_team_cc"]}
            rules={[emailsValidator]}
          >
            <Select
              mode="tags"
              options={[]}
              allowClear
            />
          </Form.Item>
        </>
      )}
    </div>
  )
}

export default InformTeamWorkflowFields
